document.addEventListener("DOMContentLoaded", (event) => {
  async function acceleratedButtonCheckout(product_id) {
      const qty = document.getElementById(`accelerated-qty-${product_id}`);

      const formData = {
          items: [
              {
              id: product_id,
              quantity: parseInt(qty.value),
              },
          ],
      };

      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
      });


      window.location.href = "/checkout";

  }

  const acceleratedButton = document.getElementById("custom-accelerated-button");
  if (acceleratedButton) {
      const product_id = acceleratedButton.getAttribute("data-product-id");

      // FixOEM: el campo oculto "accelerated-qty-{id}" traía SIEMPRE value="1"
      // fijo -- nunca se actualizaba con la cantidad que el cliente elige en
      // el selector visible de cantidad. Por eso "Compra ahora" ignoraba la
      // cantidad seleccionada (siempre compraba 1 pieza). Aquí se sincroniza
      // ese campo oculto con el input real de cantidad cada vez que cambia,
      // para que "Compra ahora" respete la cantidad elegida igual que
      // "Agregar al Carrito".
      const acceleratedQtyInput = document.getElementById(`accelerated-qty-${product_id}`);
      const realQtyInput = document.querySelector('input[name="quantity"][type="number"]');
      if (acceleratedQtyInput && realQtyInput) {
        const syncQty = () => { acceleratedQtyInput.value = realQtyInput.value || 1; };
        syncQty();
        realQtyInput.addEventListener('input', syncQty);
        realQtyInput.addEventListener('change', syncQty);
      }

      acceleratedButton.addEventListener("click", () => {
          acceleratedButtonCheckout(product_id);
      });
  }

});